import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import AudioSchema from './schema';

const AudioData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;

  const schema = AudioSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

AudioData.propTypes = {
  data: PropTypes.shape({
    url: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object,
    ]),
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default AudioData;
